/* eslint-disable promise/param-names */
import { AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT } from '../actions/auth'
import apiCall from '../../utils/api'

// const state = { token: localStorage.getItem('user-id') || '', status: '', hasLoadedOnce: false }

const getters = {
  // isAuthenticated: state => !!state.token,
  // authStatus: state => state.status,
  // token: state => state.token
}

const actions = {
  [AUTH_REQUEST]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      apiCall({url: '/sso/authorizeEvent', data: null, method: 'GET'})
        .then(resp => {
          if (resp.data.customerUid != null && resp.data.customerUid !== 'none') {
            // localStorage.setItem('user-id', resp.data.customerUid)
            // localStorage.setItem('user-name', resp.data.name)
            commit(AUTH_SUCCESS, resp)
          } else {
            commit(AUTH_ERROR)
          }
          // Here set the header of your ajax library to the token value.
          // example with axios
          // axios.defaults.headers.common['Authorization'] = resp.token
          resolve(resp)
        })
        .catch(err => {
          commit(AUTH_ERROR, err)
          reject(err)
        })
    })
  },
  [AUTH_LOGOUT]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_LOGOUT)
      // localStorage.removeItem('user-id')
      resolve()
    })
  }
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = 'success'
    state.token = resp.customerUid
    state.hasLoadedOnce = true
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error'
    state.hasLoadedOnce = true
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = ''
  }
}

export default {
  // state,
  getters,
  actions,
  mutations
}
